
























import { Component, Watch } from 'vue-property-decorator'
import {
    DropdownInputOptions,
    MultiValue,
    OpenEndedInput,
    RadioInputOptions
} from '@/components/ui/DynamicTechTaskCard/types/input-field'
import AsyncValueMixin from '@/dynamic-tech-task/components/input/mixins/async-values'


@Component
export default class RadioInputField extends AsyncValueMixin<DropdownInputOptions, MultiValue> {
    radioValue: string|null = null
    textInputValue = ''

    async mounted() {
        this.inputSetup()
    }

    /**
     * Set up the radio and text inputs depending on what the initial value is.
     * If the initial value is one of the pre-defined values, the text field is empty and the radio input for the value
     *  is selected.
     * If the initial value is not one of the pre-defined values, we assume it is an open ended input. We set the
     *  text field to this value and select the open ended radio input.
     */
    inputSetup() {
        let radioValue: string|null = null
        const fieldValue: string|null = (this.inputData[this.inputField.key] as string|null)
        if (fieldValue !== null) {
            radioValue = (this.inputField.inputOptions as RadioInputOptions).openEndedInput?.display || null
            this.textInputValue = fieldValue
            for (const item of this.inputValues) {
                if (item.value === fieldValue) {
                    radioValue = fieldValue
                    this.textInputValue = ''
                    break
                }
            }
        }
        this.radioValue = radioValue
    }

    get value() {
        return this.inputData[this.inputField.key]
    }

    @Watch('value')
    watchValue() {
        this.inputSetup()
    }

    get openEndedInput(): OpenEndedInput|null {
        return (this.inputField.inputOptions as RadioInputOptions)?.openEndedInput
    }

    get displayTextField(): boolean {
        return !!this.openEndedInput && this.radioValue === this.openEndedInput.display
    }

    onTextFieldInput(value: string) {
        if (this.displayTextField) {
            this.$emit('input', value)
        }
    }

    onRadioInput(value: string) {
        this.radioValue = value
        if (this.displayTextField) {
            this.$emit('input', this.textInputValue)
        } else {
            this.$emit('input', value)
        }
    }
}
